import { render } from "./Home_Tips.vue?vue&type=template&id=788c24c1&scoped=true&lang=pug"
import script from "./Home_Tips.vue?vue&type=script&lang=js"
export * from "./Home_Tips.vue?vue&type=script&lang=js"

import "./Home_Tips.vue?vue&type=style&index=0&id=788c24c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788c24c1"]])

export default __exports__